import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useMediaQuery } from 'react-responsive';
import OutlineInfo from 'react-md-icon/dist/OutlineInfo';

import { Toaster, DownloadButton, DeleteButton, OptionsDropdown, CloseButton } from '../../../components';
import './EditDocumentHeader.scss';

const EditDocumentHeader = ({
  toggle,
  downloadAction,
  toggleDetailsPane,
  isDeleteButtonDisabled,
  selectedDocument,
  deleteAction,
  deleteQuestionDetail,
  isAdminOrAbove,
}) => {
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const [isDeleteTooltipOpen, setIsDeleteTooltipOpen] = useState(false);
  const isDesktopOrLaptop = useMediaQuery({ minDeviceWidth: 1224 });

  const toggleDropdown = () => {
    if (!isDeleteTooltipOpen) {
      setIsMobileDropdownOpen(!isMobileDropdownOpen);
    }
  };

  const downloadButton = () => (
    <DownloadButton
      tabIndex="0"
      onClick={(e) => {
        e.stopPropagation();
        downloadAction();
        toggleDropdown();
      }}
      expandedButton
    />
  );

  const deleteButton = (deleteMessage = null, setTooltipIsOpen = null, tooltipIsOpen = null) => (
    <DeleteButton
      id={selectedDocument.id}
      additionalInfo={{
        companyId: selectedDocument.companyId,
        employeeId: selectedDocument.employeeId,
      }}
      uniqueId="delete-document-header"
      outsideClickIgnoreClass="delete-tooltip"
      deleteQuestion="DELETE_DOCUMENT_QUESTION"
      deleteQuestionDetail={deleteMessage}
      disabled={{
            isDisabled: isDeleteButtonDisabled,
            toolTipMessage: 'DOCUMENT_TYPE_CANNOT_BE_DELETED_MESSAGE',
          }}
      expandedButton
      setTooltipIsOpen={setTooltipIsOpen}
      tooltipIsOpen={tooltipIsOpen}
      deleteAction={deleteAction}
    />
  );

  const detailsButton = () => (
    <button
      className="d-flex btn align-items-center btn-wrapper btn-wrapper-enabled btn-link"
      onClick={(e) => {
        e.stopPropagation();
        toggleDetailsPane();
        toggleDropdown();
      }}
      tabIndex="0"
    >
      <OutlineInfo style={{ fontSize: '1.5rem' }} />
      <div className="d-inline pl-2 header-text"><FormattedMessage id="DETAILS" /></div>
    </button>
  );

  const buttons = [detailsButton()];

  if (downloadAction) buttons.push(downloadButton());

  buttons.push('divider');
  buttons.push(deleteButton('THIS_ACTION_CANNOT_BE_UNDONE', setIsDeleteTooltipOpen, isDeleteTooltipOpen));

  return (
    <Fragment>
      <div className="modal-header pl-4 pr-2 d-flex align-items-center" id="edit-document-header">
        <h5 className="modal-title">
          {selectedDocument.title}
        </h5>
        {!isDesktopOrLaptop ?
          /* mobile view */
          <div className="align-items-center d-flex">
            <OptionsDropdown items={buttons} toggleDropdown={toggleDropdown} isDropdownOpen={isMobileDropdownOpen} />
            <CloseButton onClick={toggle} />
          </div>
        :
          /* non-mobile view */
          <div className="align-items-right d-flex">
            {
                downloadAction ?
                  downloadButton()
                :
                  undefined
              }
            { isAdminOrAbove ?
                  deleteButton(deleteQuestionDetail || 'THIS_ACTION_CANNOT_BE_UNDONE')
                :
              undefined
            }

            {detailsButton()}
            <CloseButton onClick={toggle} />
          </div>
        }
      </div>
      <Toaster classNames={['mb-0', 'banner']} renderLocation="drawer" />
    </Fragment>
  );
};


EditDocumentHeader.defaultProps = {
  downloadAction: undefined,
  selectedDocument: {},
  isDeleteButtonDisabled: false,
  deleteAction: null,
  deleteQuestionDetail: null,
  isAdminOrAbove: false,
};

EditDocumentHeader.propTypes = {
  toggle: PropTypes.func.isRequired,
  downloadAction: PropTypes.func,
  isDeleteButtonDisabled: PropTypes.bool,
  toggleDetailsPane: PropTypes.func.isRequired,
  deleteAction: PropTypes.func,
  deleteQuestionDetail: PropTypes.string,
  isAdminOrAbove: PropTypes.bool,
  selectedDocument: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    fileName: PropTypes.string,
    category: PropTypes.string,
    uploadDate: PropTypes.string,
    extension: PropTypes.string,
    isPublishedToEmployee: PropTypes.bool,
    companyId: PropTypes.number,
    companyName: PropTypes.string,
    employeeId: PropTypes.number,
    employeeName: PropTypes.string,
    isOnboarding: PropTypes.bool,
    uploadedBy: PropTypes.string,
    isLegacyDocument: PropTypes.bool,
    isEsignatureDocument: PropTypes.bool,
    isHelloSignDocument: PropTypes.bool,
    status: PropTypes.shape({
      name: PropTypes.string,
      priority: PropTypes.number,
      stepNumber: PropTypes.number,
      isProcessing: PropTypes.bool,
    }),
  }),
};

export default EditDocumentHeader;



// WEBPACK FOOTER //
// ./src/containers/EditDocument/EditDocumentHeader/EditDocumentHeader.jsx